export default "__VITE_ASSET__B$ZiX53N__"